import { render, staticRenderFns } from "./NoticiasMercadoDashboard.vue?vue&type=template&id=4df064f6&"
import script from "./NoticiasMercadoDashboard.vue?vue&type=script&lang=js&"
export * from "./NoticiasMercadoDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports